import * as yup from 'yup';

export const supplierValidation = yup.object().shape({
    companyId: yup.string().required('Harus diisi'),
    namaSupplier: yup.string().required('Harus diisi'),
    alamat: yup.string().required('Harus diisi'),
    email: yup.string().email('Email harus valid').required('Harus diisi'),
    telepon: yup.string().matches(/^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/, 'Nomor telepon harus valid').required('Harus diisi'),
    fax: yup.string().matches(/^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/, 'Nomor fax harus valid').required('Harus diisi'),
    longitude: yup.number().required('Harus diisi'),
    latitude: yup.number().required('Harus diisi'),
    provinceId: yup.string().required('Harus diisi'),
    regencyId: yup.string().required('Harus diisi'),
    districtId: yup.string().required('Harus diisi'),
    villageId: yup.string().required('Harus diisi'),
    dataPICIds: yup.array().min(1, 'Minimal 1 PIC').required('Harus diisi'),
}).required()

export const inlineSupplierValidation = yup.object().shape({
    namaSupplier: yup.string().required('Harus diisi'),
    alamat: yup.string().required('Harus diisi'),
    email: yup.string().email('Email harus valid').required('Harus diisi'),
    telepon: yup.string().matches(/^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/, 'Nomor telepon harus valid').required('Harus diisi'),
    fax: yup.string().matches(/^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/, 'Nomor fax harus valid').required('Harus diisi'),
    longitude: yup.number().required('Harus diisi'),
    latitude: yup.number().required('Harus diisi'),
    provinceId: yup.string().required('Harus diisi'),
    regencyId: yup.string().required('Harus diisi'),
    districtId: yup.string().required('Harus diisi'),
    villageId: yup.string().required('Harus diisi'),
    dataPICIds: yup.array().min(1, 'Minimal 1 PIC').required('Harus diisi'),
}).required()